export default __webpack_public_path__ + "static/media/videoJuanPa.96e1f3b8.gif";